export const PROVIDE_LABEL_OPTIONS = {
  PRINT: 'PRINT',
  EMAIL: 'EMAIL',
  LABELLESS: 'LABELLESS',
  MAIL: 'MAIL'
};
